import PropTypes from 'prop-types';
import React from 'react';

import { Rating } from '../../Bazaarvoice/Rating';

const CMSRating = () => (
  <>
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <Rating />
  </>
);

CMSRating.propTypes = {
  content: PropTypes.shape({
    copy: PropTypes.shape({}).isRequired,
  }),
};

CMSRating.defaultProps = {
  content: {
    copy: {},
  },
};

export default CMSRating;
